import { render, staticRenderFns } from "./BtnPrimary.vue?vue&type=template&id=2dee57f1&"
import script from "./BtnPrimary.vue?vue&type=script&lang=js&"
export * from "./BtnPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports